import React from 'react';

import RowActionButton, {
  MenuKeyType,
} from 'commons/components/RowActionButton/RowActionButton.component';
import { BinListRowAction } from 'commons/enums';
import { ProductDetail } from 'commons/types';

const BinRowActionBtn: React.FC<{
  bin: ProductDetail;
  onClickEditQty: (bin: ProductDetail) => void;
  onClickEditInventoryNumber: (bin: ProductDetail) => void;
}> = ({ bin, onClickEditQty, onClickEditInventoryNumber }) => {
  const [open, setOpen] = React.useState(false);

  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const options: {
    label: string;
    key: BinListRowAction;
  }[] = [
    { label: 'Edit Quantity', key: BinListRowAction.EDIT_QTY },
    {
      label: 'Edit Inventory Number',
      key: BinListRowAction.EDIT_INVENTORY_NUMBER,
    },
  ];

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleMenuClick = (menuKey: MenuKeyType) => {
    switch (menuKey) {
      case BinListRowAction.EDIT_QTY:
        onClickEditQty(bin);
        break;
      case BinListRowAction.EDIT_INVENTORY_NUMBER:
        onClickEditInventoryNumber(bin);
        break;
      default:
    }
  };

  return (
    <RowActionButton
      open={open}
      options={options}
      handleClose={handleClose}
      handleMenuClick={handleMenuClick}
      handleToggle={handleToggle}
    />
  );
};
export default BinRowActionBtn;
